import { BaseService } from 'src/app/core/services/base.service';
import { GeneralStoreService } from './core/store/general.store';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { EnvironmentSettings } from './core/models/environment-settings';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'PortalBase';

  constructor(
    public generalStoreService: GeneralStoreService,
    public baseService: BaseService
  ) { }

  ngOnInit() {
    this.baseService.executePublicCommand<EnvironmentSettings>('portal_public_application_initialize_environment', {
      apiUrl: environment.apiUrl,
      appVersion: environment.apiUrl,
      apiVersion: environment.apiVersion,
      appCode: environment.appCode,
      mainMenuKey: environment.mainMenuKey
    }).subscribe(response => {
      if (response.responseCode === 0) {
        this.generalStoreService.setEnvironmentSettings(response.data);
      }
    });
  }


}
